<template>
	<v-container grid-list-md class="pa-0">
		<v-flex xs12 md12 v-if="!item.uuid">
			<ValidationProvider
				name="time"
				rules="required"
				v-slot="{ errors, valid }"
			>
				<v-autocomplete
					:items="outlets"
					item-value="id"
					item-text="name"
					:label="$t('Outlet')"
					v-model="item.outlet_id"
					prepend-icon="mdi-store"
					data-vv-name="outlet_id"
					required
					filled
					:readonly="item.readonly"
					:error-messages="errors"
					:append-icon="valid ? 'mdi-check' : null"
				>
				</v-autocomplete>
			</ValidationProvider>
		</v-flex>

		<v-subheader class="pa-0">
			<strong>{{ $t("label.detail") }}</strong>
		</v-subheader>
		<v-layout row wrap>
			<v-flex xs12 md6>
				<ValidationProvider
					name="time"
					rules="required"
					v-slot="{ errors, valid }"
				>
					<v-combobox
						v-model="item.adults"
						:items="adults"
						type="number"
						prepend-icon="mdi-account-multiple"
						:label="$t('Adults')"
						data-vv-name="adults"
						:readonly="item.readonly"
						:error-messages="errors"
						:append-icon="valid ? 'mdi-check' : null"
					></v-combobox>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider
					name="time"
					rules="required"
					v-slot="{ errors, valid }"
				>
					<v-combobox
						v-model="item.children"
						type="number"
						:items="children"
						prepend-icon="mdi-baby-face"
						:label="$t('Children')"
						data-vv-name="children"
						:readonly="item.readonly"
						:error-messages="errors"
						:append-icon="valid ? 'mdi-check' : null"
					></v-combobox>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider
					name="date"
					rules="required"
					v-slot="{ errors, valid }"
				>
					<v-menu
						v-model="menu1"
						:close-on-content-click="false"
						max-width="290"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								:value="computedDateFormattedMomentjs"
								label="Date"
								readonly
								v-bind="attrs"
								v-on="on"
								@click:clear="item.date = null"
								prepend-icon="mdi-calendar"
								data-vv-name="date"
								:error-messages="errors"
								:append-icon="valid ? 'mdi-check' : null"
								class="required"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="item.date"
							@change="menu1 = false"
							:min="today"
						></v-date-picker>
					</v-menu>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md6>
				<ValidationProvider
					name="time"
					rules="required"
					v-slot="{ errors, valid }"
				>
					<v-combobox
						:label="$t('Time')"
						:items="times"
						item-value="value"
						item-text="text"
						v-model="item.time"
						:return-object="false"
						prepend-icon="mdi-clock"
						data-vv-name="reservation.time"
						:error-messages="errors"
						class="required"
						:append-icon="valid ? 'mdi-check' : null"
						:loading="$wait.is('getting times')"
						loader-height="5"
					>
					</v-combobox>
				</ValidationProvider>
			</v-flex>
			<v-flex xs12 md12>
				<v-textarea
					:label="$t('Comment')"
					prepend-icon="mdi-comment"
					v-model="item.description"
					rows="3"
					data-vv-name="description"
					:readonly="item.readonly"
				>
				</v-textarea>
			</v-flex>
		</v-layout>
		<v-subheader
			><strong>{{ $t("Status") }}</strong>
		</v-subheader>
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn-toggle
					v-model="item.status"
					borderless
					active-class="white--text"
					:readonly="item.readonly"
					mandatory
				>
					<v-btn
						v-for="(status, index) in statuses"
						:key="index"
						:value="index"
						:color="status.color"
						dark
					>
						<v-icon
							left
							v-if="item.status == index"
							dark
							color="white"
							>mdi-check</v-icon
						>
						<span>{{ status.name }}</span>
					</v-btn>
				</v-btn-toggle>
			</v-flex>
		</v-layout>
		<v-layout
			row
			wrap
			v-if="item.status == 'confirmed' || item.status == 'completed'"
			class="mt-4"
		>
			<v-flex xs12>
				<v-autocomplete
					v-model="item.options.table_ids"
					:items="tables"
					item-value="id"
					item-text="name"
					:label="$t('label.assign_table')"
					multiple
					chips
					deletable-chips
				></v-autocomplete>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
	import moment from "moment";
	import { format, parseISO } from "date-fns";
	export default {
		props: [
			"value",
			"tables",
			"outlets",
			"detail",
			"statuses",
			"adults",
			"children",
			"tables",
		],
		data() {
			return {
				today: format(parseISO(new Date().toISOString()), "yyyy-MM-dd"),
				menu1: false,
				loaded: false,
				times: [],
				search: "",
			};
		},

		computed: {
			item: {
				get() {
					return this.value;
				},
				set(value) {
					this.$emit("input", value);
				},
			},

			computedDateFormattedMomentjs() {
				return this.item.date
					? moment(this.item.date).format("dddd, MMMM Do YYYY")
					: "";
			},
		},

		watch: {
			"item.date": {
				async handler() {
					if (this.item.date && this.item.outlet_id) {
						await this.getReservationShift();
					}
				},
				immediate: false,
			},
			"item.outlet_id": {
				async handler() {
					if (this.item.date && this.item.outlet_id) {
						await this.getReservationShift();
					}
				},
				immediate: false,
			},
		},

		methods: {
			async getReservationShift() {
				try {
					this.$wait.start("getting times");

					if (this.$route().current("tenant.*")) {
						var route = this.$route("tenant.reservation_times.index", {
							tenant: this.$page.props.tenant.id,
						});
					} else {
						var route = this.$route("central.reservation_times.index");
					}

					const response = await axios.get(route, {
						params: {
							outlet_id: this.item.outlet_id,
							date: this.item.date,
						},
					});
					if (response.data.success) {
						if (this.loaded) {
							this.item.time = null;
						}
						this.times = response.data.data;
						this.loaded = true;
					} else {
						this.$toast.error(response.data.data);
					}
				} catch (error) {
					this.$toast.error(error.message);
				} finally {
					this.$wait.end("getting times");
				}
			},
		},
	};
</script>